<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">                       
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>                               
                                  <e-column field='uuid' headerText='UUID' aria-required="true" :isPrimaryKey='true' width='150'></e-column>
                                  <e-column field='brand' headerText='品牌' width='150'></e-column>
                                  <e-column field='phone_name' headerText='手機名稱' width='150'></e-column>
                                  <e-column field='phone_os' headerText='作業系統' width='150'></e-column>
                                  <e-column field='type' headerText='類型' width='150'></e-column>
                                  <e-column field='plat_from' headerText='型號' width='150'></e-column>                                  
                                  <e-column field='create_date' headerText='建立時間' width='180'></e-column>
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>           
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars"
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";


setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
        'Print': '列印',
        'Search': '搜尋'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(TextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DatePickerPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(Loading);

let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent
  },
  data: function () {
    return {  
    
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      datas: null,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,

      toolbar : [{ text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'],
    };
  },
  methods: {    
    toolbarClick: function (args) {     
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'使用者資料.xlsx' });
      }   
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }    
    },

    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },   
    getUUID: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `AppManager/UUID`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.getUUID();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}
</style>
<style lang="scss" src="../../scss/base.scss"></style>
